import { defineType } from 'sanity';

export const grid = defineType({
    type: 'object',
    name: 'grid',
    title: 'Grid Layout Wrapper',
    fields: [
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: '4 col', value: 'A' },
                    { title: '3 col', value: 'B' },
                    { title: '2 col', value: 'C' },
                    { title: '1 col', value: 'D' },
                ],
            },
        },
    ],
});
